import apiUrl from '../../../../constants'
import user_tracker from '../../../../usertracker'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'
import { BasicSelect ,ModelSelect} from 'vue-search-select';

export default {
	name: 'auto-handover',
	
  components: {
    BasicSelect,
		ModelSelect,
    VueElementLoading,
    Multiselect
  },
	data: function() {
		return {
			isLoading: false,
			listHubZone: [],
			liststateData: [],
			autoenable: true,
			zoneId:'',
			zone:[],
			stateId: '',
			state: [],
			cityId: '',
			city: [],
			HubArr: [],
			hubtype: '',
			hubtypeId: [],
			hub: [],
			hubId: '',
			cityList: [],
			hubtypelist : [
				{ value : 1,  text: "SC" },
				{ value : 2,  text: "RSC" },
				{ value : 3,  text: "Hub PC" },
				{ value : 4,  text: "Hub LH" },
				{ value : 5,  text: "Hub DMG" },
				{ value : 6,  text: "Hub TSP" },
				{ value : 7,  text: "WH" },
				{ value : 8,  text: "RTO" },
				{ value : 9,  text: "RVP" },
				{ value : 10, text: "HO/RO" },
				{ value : 11, text: "WMS" },
				{ value : 12, text: "Terminal" }
			],
			hublist: [],
			bagOutHubAndBagDetails:[],
		 	isAllHub:'',
		 	hubIdArr:[],
		 	hubIdList:[],
			checkedHub: [],
			hubbagList: [],
			bagList: [],
	    checkAllHub: false,
			disableHub: false,
			checkAllSurface: false,
			checkAllRTO: false,
			checkAllDTO: false,
			checkAllAIR: false,
			checkAllNDD: false,
			checkAllDOC: false,
			checkAllRSC: false,
			checkAllMaster: false,
			checkAllSurfaceCargo: false,
			checkAllAirCargo: false,
	    disableBag: [],
			checkedSurfaceBag: [],
			checkedRTOBag: [],
			checkedDTOBag: [],
			checkedAirBag: [],
			checkedNDDBag: [],
			checkedDOCBag: [],
			checkedRSCBag: [],
			checkedMasterBag: [],
			checkedSurfaceCargoBag: [],
			checkedAirCargoBag: [],
	    inputPayload: {},
			addmodalShow: false,
			closeStatusModal: false
		}
	},
	created: function() {},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.useremail = userdetail[0].email;

		this.getHubdetailsFromFMS();
	},
	methods: {
		selectedZone(val) {
			this.zoneId = val.zoneId;
			this.$validator.reset();
				this.state= '',
				this.stateId= '',
				this.city='',
				this.cityId='',
				this.hubtype='',
				this.hubtypeId='',
				this.hub='',
				this.hubId='',
				this.liststateData=[],
				this.hublist=[],
				this.cityList=[],
				this.bagOutHubAndBagDetails=[],
			this.getHubdetailsFromFMS();
		},

		selectedState(val) {
			this.stateId = val.stateId;
			this.$validator.reset();
			this.city='',
			this.cityId='',
			this.hubtype='',
			this.hubtypeId='',
			this.hub='',
			this.hubId='',
			this.hublist=[],
			this.cityList=[],
			this.bagOutHubAndBagDetails=[],
			this.getHubdetailsFromFMS();
		},

		selectedCity(val) {
			this.cityId = val.cityId;
			this.$validator.reset();
			this.hubtype='',
			this.hubtypeId='',
			this.hub='',
			this.hubId='',
			this.hublist=[],
			this.bagOutHubAndBagDetails=[],
			this.getHubdetailsFromFMS();
		},

		selectedHubtype(val) {
			this.hubtypeId = val.text;
			this.bagOutHubAndBagDetails=[],
			this.$validator.reset()
		},

		selectedHub(val) {
			this.hubId = val.facilityId;
			this.bagOutHubAndBagDetails=[],
			this.$validator.reset()
		},

		getHubdetailsFromFMS(){

			this.input = ({
				facilityIds:[],
				stateIds: this.stateId ? [this.stateId] : [],
				cityIds: this.cityId ? [this.cityId] : [],
				zoneIds: this.zoneId ? [this.zoneId] : []
		  });

			this.isLoading = true;

			axios({
			  method: 'Post',
			  'url': apiUrl.api_url_hubops + 'getHubdetailsFromFMS',
			  'data': this.input,
			  headers: {
				'authorization': 'authkey xB84JJ89Hd25',
			  }
			})
			.then(result => {

			  if (result.data.ResultCode == 100) {
					this.listHubZone = (this.listHubZone.length >0) ? this.listHubZone :result.data.ResponseData.listOfZone;
					this.liststateData = (this.liststateData.length >0) ? this.liststateData :result.data.ResponseData.listOfState;
					this.cityList = (this.cityList.length >0) ? this.cityList :result.data.ResponseData.listOfCity;
					this.hublist = (this.hublist.length >0) ? this.hublist :result.data.ResponseData.facilitiesDetails;
			  }else{
					this.$alertify.error(result.data.ReturnMessage);
			  }
				this.isLoading = false;
			}, error => {
				this.isLoading = false;
			  console.error(error);
				this.$alertify.error(error.ReturnMessage);
			})
		},

		getFilteredRecordForAutoBagout(){
			this.bagOutHubAndBagDetails = [];
			this.hubIdArr = [];
			this.bagList =[];
			this.input = 'autoBagoutEnabledFacility=' + this.autoenable + '&hubzoneId=' +this.zoneId + '&stateId=' + this.stateId + '&cityId=' + this.cityId +
			'&hubId=' + this.hubId + '&hubType=' + (this.hubtype ? this.hubtype.text : '');

			this.isLoading = true;

			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'getFilteredRecordForAutoBagOut?' + this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(async result => {

			  if (result.data.ResultCode == 100 && result.data.bagOutConfigFacilityAndBagDetails.length > 0) {

					this.bagOutHubAndBagDetails = result.data.bagOutConfigFacilityAndBagDetails;
			    this.hubIdArr = [...new Set(result.data.bagOutConfigFacilityAndBagDetails.map(a => a.hubId))];

					await this.setBagTpe();
			  }else{
					this.$alertify.error(result.data.ReturnMessage);
			  }

				this.isLoading = false;
			}, error => {

				this.isLoading = false;
			  console.error(error);
				this.$alertify.error(error.ReturnMessage);
			})
		},

		async setBagTpe() {

			this.resetData();

			for (const elem of this.bagOutHubAndBagDetails) {

				if(elem.autoBagOutEnabled){
					this.checkedHub[elem.hubId] = true;
				}

				if(elem.SurfaceBag) this.checkedSurfaceBag[elem.hubId] = true;
				if(elem.RTOBag) this.checkedRTOBag[elem.hubId] = true;
				if(elem.DTOBag) this.checkedDTOBag[elem.hubId] = true;
				if(elem.AirBag) this.checkedAirBag[elem.hubId] = true;
				if(elem.NDDBag) this.checkedNDDBag[elem.hubId] = true;
				if(elem.DOCBag) this.checkedDOCBag[elem.hubId] = true;
				if(elem.RSCBag) this.checkedRSCBag[elem.hubId] = true;
				if(elem.MasterBag) this.checkedMasterBag[elem.hubId] = true;
				if(elem.SurfaceCargoBag) this.checkedSurfaceCargoBag[elem.hubId] = true;
				if(elem.AirCargoBag) this.checkedAirCargoBag[elem.hubId] = true;
			}

			// let hubLength = this.hubIdArr.length;
			//
			// if(this.hubIdArr.length > 0){
			// 	if(this.checkedSurfaceBag.filter(item => typeof item !== 'undefined').length === hubLength) {	this.checkAllSurface = true; }
			// 	if(this.checkedRTOBag.filter(item => typeof item !== 'undefined').length === hubLength) {	this.checkAllRTO = true; }
			// 	if(this.checkedDTOBag.filter(item => typeof item !== 'undefined').length === hubLength) {	this.checkAllDTO = true; }
			// 	if(this.checkedAirBag.filter(item => typeof item !== 'undefined').length === hubLength) {	this.checkAllAIR = true; }
			// 	if(this.checkedNDDBag.filter(item => typeof item !== 'undefined').length === hubLength) {	this.checkAllNDD = true; }
			// 	if(this.checkedDOCBag.filter(item => typeof item !== 'undefined').length === hubLength) {	this.checkAllDOC = true; }
			// 	if(this.checkedRSCBag.filter(item => typeof item !== 'undefined').length === hubLength) {	this.checkAllRSC = true; }
			// 	if(this.checkedMasterBag.filter(item => typeof item !== 'undefined').length === hubLength) {	this.checkAllMaster = true; }
			// 	if(this.checkedSurfaceCargoBag.filter(item => typeof item !== 'undefined').length === hubLength) {	this.checkAllSurfaceCargo = true; }
			// 	if(this.checkedAirCargoBag.filter(item => typeof item !== 'undefined').length === hubLength) {	this.checkAllAirCargo = true; }
			// }
		},

		// Case 1: For Case when user is enabling or disabling all facilities based on filter
		checkAllFacility(event) {
			if (this.bagList.length >0) {
				this.setBagTpe();
			}

			let active = event.target.checked;

			this.isLoading = true;

			this.inputPayload = {};
			this.checkAllHub 	= active;

			if(this.checkAllHub) {
				for (const elem of this.hubIdArr) {
					this.checkedHub[elem] = active;
				}
			} else {
				this.checkedHub = []
			}

			this.disableHub = this.checkAllHub;
			this.isAllHub 	= active;

			this.inputPayload.isAllHub = active;
			this.isLoading = false;
    },

		// Case 4: For Case when user is enabling or disabling some facilities based on filter
		updateCheckDest(hub,event) {

			let active = event.target.checked;
			this.inputPayload 		= {};
			this.checkedHub[hub] 	= active;

			// if(active==false){
			//
			//  	this.hubIdArr = this.hubIdArr.filter(el => el != hub)
			// }else{
			//  	if(this.hubIdArr.indexOf(hub) === -1) this.hubIdArr.push(hub);
			// }
			//
			// this.checkAllHub = (this.bagOutHubAndBagDetails.length === this.hubIdArr.length) ? true : false;

			// Check if an object with the given 'bag' value already exists
			let found = this.hubIdList.find(item => item.hub === hub);
	    if (found) {
				// Update the isActive value of the existing bag entry
				found.isActive = active;
	    } else {

				let newObj = {
					hub: hub,
					isActive: active
				};
				this.hubIdList.push(newObj);
	    }

			this.inputPayload.hubList = this.hubIdList;
		},

		// Case 2: For Case when user is enabling or disabling bagTypes of all facility based on filter
		checkAllBagType(bag, event) {
			if (this.checkAllHub) {
				this.setBagTpe();
			}

			if(this.hubbagList.length>0) {
				this.setBagTpe();
			}

			let active = event.target.checked;

			this.isLoading = true;

			this.inputPayload 		= {};
			this.disableBag[bag] 	= active;

			if(active) {
				for (const elem of this.hubIdArr) {

					if(bag == 'SurfaceBag') { this.checkAllSurface = active; this.checkedSurfaceBag[elem] = active; }
					else if(bag == 'RTOBag') { this.checkAllRTO = active; this.checkedRTOBag[elem] = active; }
					else if(bag == 'DTOBag') { this.checkAllDTO = active; this.checkedDTOBag[elem] = active; }
					else if(bag == 'AirBag') { this.checkAllAIR = active; this.checkedAirBag[elem] = active; }
					else if(bag == 'NDDBag') { this.checkAllNDD = active; this.checkedNDDBag[elem] = active; }
					else if(bag == 'DOCBag') { this.checkAllDOC = active; this.checkedDOCBag[elem] = active; }
					else if(bag == 'RSCBag') { this.checkAllRSC = active; this.checkedRSCBag[elem] = active; }
					else if(bag == 'MasterBag') { this.checkAllMaster = active; this.checkedMasterBag[elem] = active; }
					else if(bag == 'SurfaceCargoBag') { this.checkAllSurfaceCargo = active; this.checkedSurfaceCargoBag[elem] = active; }
					else if(bag == 'AirCargoBag') { this.checkAllAirCargo = active; this.checkedAirCargoBag[elem] = active; }
				}
			} else{

				if(bag == 'SurfaceBag') { this.checkAllSurface = active; this.checkedSurfaceBag = []; }
				else if(bag == 'RTOBag') { this.checkAllRTO = active; this.checkedRTOBag = []; }
				else if(bag == 'DTOBag') { this.checkAllDTO = active; this.checkedDTOBag = []; }
				else if(bag == 'AirBag') { this.checkAllAIR = active; this.checkedAirBag = []; }
				else if(bag == 'NDDBag') { this.checkAllNDD = active; this.checkedNDDBag = []; }
				else if(bag == 'DOCBag') { this.checkAllDOC = active; this.checkedDOCBag = []; }
				else if(bag == 'RSCBag') { this.checkAllRSC = active; this.checkedRSCBag = []; }
				else if(bag == 'MasterBag') { this.checkAllMaster = active; this.checkedMasterBag = []; }
				else if(bag == 'SurfaceCargoBag') { this.checkAllSurfaceCargo = active; this.checkedSurfaceCargoBag = []; }
				else if(bag == 'AirCargoBag') { this.checkAllAirCargo = active; this.checkedAirCargoBag = []; }
			}

			// Check if an object with the given 'bag' value already exists
			let found = this.bagList.find(item => item.bagtype === bag);
	    if (found) {
				// Update the isActive value of the existing bag entry
				found.isActive = active;
	    } else {

				let newObj = {
					bagtype: bag,
					isActive: active
				};
				this.bagList.push(newObj);
	    }

			this.inputPayload.bagList = this.bagList;
			this.hubbagList = [];

			this.isLoading = false;
		},

		// Case 3: For Case when user is enabling or disabling bagTypes of selected enabled facility based on filter
		checkBagType(hub, bag, event) {

			if(this.bagList.length>0) {
				this.setBagTpe();
			}

			let active = event.target.checked;
			this.inputPayload = {};

			if(bag == 'SurfaceBag') { this.checkedSurfaceBag[hub] = active; }
			else if(bag == 'RTOBag') { this.checkedRTOBag[hub] = active; }
			else if(bag == 'DTOBag') { this.checkedDTOBag[hub] = active; }
			else if(bag == 'AirBag') { this.checkedAirBag[hub] = active; }
			else if(bag == 'NDDBag') { this.checkedNDDBag[hub] = active; }
			else if(bag == 'DOCBag') { this.checkedDOCBag[hub] = active; }
			else if(bag == 'RSCBag') { this.checkedRSCBag[hub] = active; }
			else if(bag == 'MasterBag') { this.checkedMasterBag[hub] = active; }
			else if(bag == 'SurfaceCargoBag') { this.checkedSurfaceCargoBag[hub] = active; }
			else if(bag == 'AirCargoBag') { this.checkedAirCargoBag[hub] = active; }

			// Check if an object with the given 'hub' value already exists in 'output'
			let found = this.hubbagList.find(item => item.hubId === hub);
	    if (found) {
	        // Check if a bag entry with the same 'bag' value already exists
				let existingBag = found.bagTypeList.find(entry => entry.bagtype === bag);

				if (existingBag) {
				  // Update the isActive value of the existing bag entry
				  existingBag.isActive = active;
				} else {
				  // Add a new bag entry
				  found.bagTypeList.push({
				      bagtype: bag,
				      isActive: active
				  });
				}
	    } else {
				// Create a new object and push it into 'output'
				let newObj = {
				  hubId: hub,
				  bagTypeList: [{
				      bagtype: bag,
				      isActive: active
				  }]
				};
				this.hubbagList.push(newObj);
	    }

			this.inputPayload.hubbagList = this.hubbagList;
			this.bagList = [];
		},

		addBagOutConfiguration() {

			this.inputPayload.hubzoneId		= this.zoneId,
			this.inputPayload.stateId 		= this.stateId,
			this.inputPayload.cityId 			= this.cityId,
			this.inputPayload.hubId 			= this.hubId,
			this.inputPayload.hubType 		= (this.hubtype) ? this.hubtype.text : '',
			this.inputPayload.modifiedby	= this.useremail;
			this.inputPayload.autoBagoutEnabledFacility	= this.autoenable;

			this.isLoading = true;

			axios({
				method: 'PUT',
				'url': apiUrl.api_url_hubops + 'updateBagTypesAndFacilities',
				'data': this.inputPayload,
				headers: {
					'Authorization': "authkey xB84JJ89Hd25"
				}
			})
			.then(result => {

				if (result.data.ResultCode == 100) {
					this.isLoading = false;
					this.$alert(result.data.ReturnMessage, "", "success");
					this.getFilteredRecordForAutoBagout();
					this.checkAllHub= false;
				} else {
					this.isLoading = false;
					this.$alert(result.data.ReturnMessage, "", "error");
				}

			}, error => {

				this.isLoading = false;
				console.error(error)
			})
		},

		cancelonclick(){
			this.resetData();
			this.getFilteredRecordForAutoBagout();
		},

		onSubmit: function() {
      this.$validator.validateAll().then((result) => {

        if (!result) {
          console.log('errors exist', this.errors);
          return false;
        } else {
					this.getFilteredRecordForAutoBagout();
        }
      }).catch((error) => {

        console.log('errors exist', error);
				this.$alertify.error(error.ReturnMessage);
      });
    },

		onSubmitHub: function(elem) {
		 this.$validator.validateAll('hubsave').then((result) => {
		   if (result) {

				 if(this.inputPayload && Object.keys(this.inputPayload).length>0) {
	 				this.addmodalShow = true;
	 			}
		   }else{
				 console.log('errors exist', this.errors);
		     return false;
		   }
		 }).catch((error) => {

			 console.log('errors exist', error);
			 this.$alertify.error(error.ReturnMessage);
		 });
		},

		resetData() {
			this.isAllHub='',
		 	this.hubIdList=[],
			this.checkedHub= [],
			this.hubbagList= [],
	    this.checkAllHub= false,
			this.disableHub= false,
	    this.disableBag= [],
			this.checkAllSurface= false,
			this.checkAllRTO= false,
			this.checkAllDTO= false,
			this.checkAllAIR= false,
			this.checkAllNDD= false,
			this.checkAllDOC= false,
			this.checkAllRSC= false,
			this.checkAllMaster= false,
			this.checkAllSurfaceCargo= false,
			this.checkAllAirCargo= false,
			this.inputPayload= {};
			this.checkedSurfaceBag= [],
			this.checkedRTOBag= [],
			this.checkedDTOBag= [],
			this.checkedAirBag= [],
			this.checkedNDDBag= [],
			this.checkedDOCBag= [],
			this.checkedRSCBag= [],
			this.checkedMasterBag= [],
			this.checkedSurfaceCargoBag= [],
			this.checkedAirCargoBag= [],
			this.addmodalShow= false,
			this.closeStatusModal= false;
		},

		resetForm() {
			this.isLoading = false,
			this.listHubZone= [],
			this.liststateData= [],
			this.autoenable= true,
			this.zoneId='',
			this.zone=[],
			this.stateId= '',
			this.state= [],
			this.cityId= '',
			this.city= [],
			this.HubArr= [],
			this.hubtype= '',
			this.hubtypeId= [],
			this.hub= [],
			this.hubId= '',
			this.cityList= [],
			this.hublist= [],
			this.bagOutHubAndBagDetails=[],
		 	this.isAllHub='',
		 	this.hubIdArr=[],
		 	this.hubIdList=[],
			this.checkedHub= [],
			this.hubbagList= [],
			this.bagList= [],
	    this.checkAllHub= false,
			this.disableHub= false,
			this.checkAllSurface= false,
			this.checkAllRTO= false,
			this.checkAllDTO= false,
			this.checkAllAIR= false,
			this.checkAllNDD= false,
			this.checkAllDOC= false,
			this.checkAllRSC= false,
			this.checkAllMaster= false,
			this.checkAllSurfaceCargo= false,
			this.checkAllAirCargo= false,
	    this.disableBag= [],
			this.checkedSurfaceBag= [],
			this.checkedRTOBag= [],
			this.checkedDTOBag= [],
			this.checkedAirBag= [],
			this.checkedNDDBag= [],
			this.checkedDOCBag= [],
			this.checkedRSCBag= [],
			this.checkedMasterBag= [],
			this.checkedSurfaceCargoBag= [],
			this.checkedAirCargoBag= [],
	    this.inputPayload= {},
			this.addmodalShow= false,
			this.closeStatusModal= false;
			this.getHubdetailsFromFMS();
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/AutoBagOutConfiguration_v1/AutoBagOutConfiguration/AutoBagOutConfiguration.js